import styled from "styled-components";

export const WearHouseWorkOrderWrapper = styled.div`
div#react-select-2-placeholder {
    position: relative;
    top: 0px !important;
}
.inner-pro-br{
    max-width: 188px;
}
.search {
    width: 100%;
    min-width: 396px;
}
.select2-container {
    min-width: 153px;
    margin: 0px !important;
}
.ag-cell.shipment_cell_id {
    font-size: 12px !important;
    padding: 8px 12px !important;
}
.card-wrapper{
    flex-direction: column;
}
span.two-line-ellipsis.user-name {
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #535E63;
}
span.two-line-ellipsis.user-email {
    font-size: 10px;
    font-weight: 600;
    line-height: 12px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #7E8A90;
    margin-top: 2px;
}
.card-wrapper.elipsises-one-line span {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.two-line-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: #535E63;
    height: auto;
}
.date-item-wrapper {
    display: flex;
    flex-direction: column;
    grid-row-gap: 3px;
    span {
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #535E63;
    &:not(:first-child){
      font-size: 10px;
      color: #989898;
      font-weight: 400;
    }
}
}
svg.delete-icon {
    color: #D95040;
    font-size: 22px;
    cursor: pointer;
}

.action-icons{
    width: 22px;
 }

`;
export const InnerTableWrapper = styled.div`
*{
  font-family: "Titillium Web", sans-serif;
}
.ag-cell.ag-cell-not-inline-editing.ag-cell-normal-height.ag-cell-value {
    border-right: 1px solid ${({ theme }) => theme['border-color']};
}
button{
  margin: auto;
  margin-bottom: 0px;
}
 .ag-header-cell{
  &::after {
    background-color: #E6E6E6;
    border-right: none;
    height: 100px;
    top: 0;
}
 }

`
